module.exports = "https://dev.stanwinstonschool.com/theshapeofwater_poster_org.987cd4dca6abcf2977d94d78da9ac86c.jpg";